"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractValidationPlugin_1 = __importDefault(require("./AbstractValidationPlugin"));
console.debug('INFO TelephoneNumberValidationPlugin.ts loaded');
var TelephoneNumberValidationPlugin = /** @class */ (function (_super) {
    __extends(TelephoneNumberValidationPlugin, _super);
    function TelephoneNumberValidationPlugin(field, countryCodeField) {
        var _this = _super.call(this, field) || this;
        _this.field = field;
        _this.countryCodeField = countryCodeField;
        return _this;
    }
    TelephoneNumberValidationPlugin.prototype.isValid = function () {
        return this._isTelephoneNumberValid();
    };
    TelephoneNumberValidationPlugin.prototype.runCustomValidation = function () {
        this._isTelephoneNumberValid();
    };
    TelephoneNumberValidationPlugin.prototype._isTelephoneNumberValid = function () {
        if (this.field.value === '' && this.countryCodeField.value !== '' && this.field.required) {
            this.field.setCustomValidity('Please enter your Number');
            return false;
        }
        else if (this.field.value === '' && this.countryCodeField.value !== '' && !this.field.required) {
            this.field.setCustomValidity('');
            return true;
        }
        else if (this.field.value !== '' && this.countryCodeField.value !== '') {
            this.field.setCustomValidity('');
            return true;
        }
        this.field.setCustomValidity('');
        return true;
    };
    TelephoneNumberValidationPlugin.prototype._getMessageAttribute = function () {
        return 'data-required-error-message';
    };
    TelephoneNumberValidationPlugin.prototype._getDefaultMessage = function () {
        return 'This field is required and needs to be filled.';
    };
    return TelephoneNumberValidationPlugin;
}(AbstractValidationPlugin_1.default));
exports.default = TelephoneNumberValidationPlugin;
